module.exports = __webpack_public_path__ + "img/zeus.ccb7074c.svg";